import { CheckCircle } from 'lucide-react';
import { TARIF_CARDS, EXTRAS_FRAIS } from './moana-data';
import { Eyebrow } from './MoanaHero';

export const MoanaTarifs = () => (
  <section id="tarifs" className="py-20 bg-[#F8FAFC]" data-testid="tarifs-section">
    <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10">
      <div className="mb-12">
        <Eyebrow>Tarifs delegation totale · 2026</Eyebrow>
        <h2 className="text-3xl sm:text-4xl font-bold text-[#1F2937]">
          Des tarifs clairs, <em className="italic text-[#F59E0B]">degressifs selon votre effectif</em>
        </h2>
        <p className="text-sm text-gray-500 leading-relaxed mt-3 max-w-[560px]">
          Applicable au Mode 1 — Délégation totale. MO + CST inclus dans chaque bulletin. Les Modes 2 et 3 font l'objet d'un devis personnalisé.
        </p>
      </div>

      {/* 3 tariff cards */}
      <div className="grid md:grid-cols-3 gap-5 mb-10">
        {TARIF_CARDS.map((tc, i) => (
          <div key={tc.palier} className={`bg-white border rounded-xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all ${i === 1 ? 'border-[#F59E0B] ring-2 ring-[#F59E0B]/20' : 'border-gray-200'}`} data-testid={`tarif-card-${i}`}>
            <div className={`${tc.bg} p-7 relative`}>
              {tc.badge && (
                <span className="absolute top-4 right-4 bg-[#F59E0B] text-[#0F766E] text-[10px] font-bold tracking-wider uppercase px-2.5 py-1 rounded">{tc.badge}</span>
              )}
              <p className="text-[10px] font-bold tracking-[0.18em] uppercase text-[#F59E0B] mb-2.5">{tc.palier}</p>
              <p className="text-4xl font-bold text-white leading-none">{tc.price} F <span className="text-base font-normal">HT</span></p>
              <p className="text-[11px] text-white/[0.38] uppercase tracking-wider mt-1.5">par salarié · par mois</p>
              {tc.reduction && <p className="text-sm text-[#F59E0B]/80 font-medium mt-2">{tc.reduction}</p>}
            </div>
            <div className="p-7">
              <p className="text-xs text-[#0D9488] font-medium mb-3">Bulletin · Decl. MO + CST · Livre de paie · OD salaire · Provisions CP inclus</p>
              <ul className="space-y-0">
                {['Bulletin de paie conforme CPS', 'Déclarations MO + CST incluses', 'Livre de paie mensuel', 'Ordre de décaissement comptable', 'Provisions congés payés'].map(item => (
                  <li key={item} className="flex gap-2 text-sm text-gray-500 py-1.5 border-b border-gray-100 last:border-0">
                    <CheckCircle className="w-3.5 h-3.5 text-green-500 flex-shrink-0 mt-0.5" /> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* Extras + Engagement */}
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white border border-gray-200 rounded-xl p-7">
          <h4 className="text-lg font-bold text-[#1F2937] mb-4">Frais d'entree & options</h4>
          {EXTRAS_FRAIS.map(f => (
            <div key={f.label} className="flex justify-between items-center text-sm py-2.5 border-b border-gray-100 last:border-0 gap-4">
              <span className="text-gray-500">{f.label}</span>
              <span className={`font-semibold whitespace-nowrap ${f.free ? 'text-green-600' : 'text-[#1F2937]'}`}>{f.val}</span>
            </div>
          ))}
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-7">
          <h4 className="text-lg font-bold text-[#1F2937] mb-4">Conditions d'engagement</h4>
          <div className="space-y-3.5">
            {[
              { badge: '6 mois', text: "Engagement 6 mois ferme. Tacite reconduction par 6 mois. Préavis 2 mois (3 mois si ancienneté > 6 mois). Rupture anticipee avec préavis 2 mois — aucune indemnité." },
              { badge: '12 mois', text: "Engagement 12 mois ferme. Tacite reconduction par 12 mois. Préavis 3 mois. Rupture anticipee avec préavis 2 mois — aucune indemnité." },
            ].map(e => (
              <div key={e.badge} className="bg-[#F8FAFC] rounded-lg p-4 flex gap-3.5 items-start">
                <span className="bg-[#0D9488] text-white text-xs font-bold px-2.5 py-1 rounded flex-shrink-0">{e.badge}</span>
                <p className="text-sm text-gray-500 leading-relaxed">{e.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
